export default function useSanitiseReg(reg: string) {
  if(!reg){
    return "";
  }
  const l = reg.length;
  if (l <= 4) {
    return reg
  }
  if(reg.length === 5){
    return reg.substring(0, 2) + " " + reg.substring(2);
  }
  if(reg.length === 6){
    return reg.substring(0, 3) + " " + reg.substring(3);
  }
  return reg.substring(0, 4) + " " + reg.substring(4);
}
